import { NgModule } from '@angular/core';
import {
  CheckboxGroupModule,
  DatePickerModule,
  NumberInputModule,
  RadioGroupModule,
  SelectModule,
  MultiSelectModule,
  TextareaModule,
  FileUploadModule,
  CheckboxModule,
  HtmlEditorModule,
} from '@certemy/ui-components';

import { DynamicFormComponent } from './dynamic-form.component';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { FileService } from 'services/file/file.service';
import { MultiselectToCheckboxWrapperComponent } from 'components/multiselect-to-checkbox-wrapper/multiselect-to-checkbox-wrapper/multiselect-to-checkbox-wrapper.component';
import { FindErrorByFieldLabelPipe } from './find-error-by-field-label.pipe';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { StepService } from 'services/professional/step/step.service';

@NgModule({
  imports: [
    CertemyCommonModule,
    RadioGroupModule,
    CheckboxGroupModule,
    DatePickerModule,
    SelectModule,
    MultiSelectModule,
    NumberInputModule,
    TextareaModule,
    FileUploadModule,
    CheckboxModule,
    NgbTooltipModule,
    HtmlEditorModule,
  ],
  exports: [DynamicFormComponent],
  declarations: [DynamicFormComponent, MultiselectToCheckboxWrapperComponent, FindErrorByFieldLabelPipe],
  providers: [FileService, StepService],
})
export class DynamicFormModule {}
